import { render, staticRenderFns } from "./AddSupplierCreditNote.vue?vue&type=template&id=0b197896&scoped=true&"
import script from "./AddSupplierCreditNote.vue?vue&type=script&lang=js&"
export * from "./AddSupplierCreditNote.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierCreditNote.vue?vue&type=style&index=0&id=0b197896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b197896",
  null
  
)

export default component.exports